/**
 * @file checkboxでdisabled on/off
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ToggleDisabled
 * @classdesc checkboxでdisabled on/off
 */
export default class ToggleDisabled {
	/**
	 * @constructor
	 * @param {jQuery} $e - [data-checkbox-toggle=true]
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._$target = $('.btn-disabled-link');
		this._targetType = this._$target.prop('tagName').toLowerCase();
		console.log(`target type is "${this._targetType}"`)
		this._$e.on('click', () => this.onClick());
		if(this._targetType === 'a'){
			this._$target.on('click', () => this.onTargetClick());
		}
	};


	/**
	 * Clickのコールバック
	 *
	 * @memberof ToggleDisabled
	 * @return {undefined}
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		let submit = true;
		$('.toggle-disabled').each((idx, e) => {
			const $e = $(e);
			if(!$e.prop('checked')) submit = false;
		});
		if(submit) {
			if(this._targetType === 'button'){
				this._$target.prop('disabled', false);
			}else{
				this._$target.removeClass('disabled');
			}
		}else{
			if(this._targetType === 'button'){
				this._$target.prop('disabled', true);
			}else{
				this._$target.addClass('disabled');
			}
		}
	};

	/**
	 * Clickのコールバック
	 *
	 * @memberof ToggleDisabled
	 * @return {undefined}
	 */
	onTargetClick() {
		console.log(`${this.constructor.name}.onTargetClick`);
		if(!this._$target.hasClass('disabled')){
			const href = this._$target.data('href');
			location.href = href;
		}
	};
}
